"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcRights = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var Layout_1 = __importDefault(require("../Layout"));
var arc_rights_docx_1 = __importDefault(require("../../static/docs/arc-rights.docx"));
var pdf_arc_rights_pdf_1 = __importDefault(require("../../static/docs/pdf-arc-rights.pdf"));
var react_router_dom_1 = require("react-router-dom");
var react_1 = require("react");
function ArcRights() {
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    (0, react_1.useEffect)(function () {
        if (pathname === '/arc-rights/download') {
            fetch(pdf_arc_rights_pdf_1.default).then(function (response) {
                response.blob().then(function (blob) {
                    // Creating new object of PDF file
                    var fileURL = window.URL.createObjectURL(blob);
                    // Setting various property values
                    var alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = 'FCH-PE-OPE-GEN-01 Solicitud de Atención de Derechos ARCO.pdf';
                    alink.click();
                });
            });
        }
    }, []);
    return (
    // <IFrame src={termAndCondition} frameBorder="0">
    // </IFrame>
    (0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.Content, { dangerouslySetInnerHTML: { __html: arc_rights_docx_1.default } }) }));
}
exports.ArcRights = ArcRights;
